import React from 'react';

import { Route, Redirect, Switch } from 'react-router-dom';

import List from './List';
import User from './User';

function Index() {
  return (
    <Switch>
      <Route exact path="/app/management/users">
        <Redirect to="/app/management/users/list" />
      </Route>

      <Route path="/app/management/users/list" component={List} />
      <Route path="/app/management/users/new" component={User} />
      <Route path="/app/management/users/:userId" component={User} />
      <Route path="/app/management/users/:userId/edit" component={User} />
    </Switch>
  );
}

export default Index;
